import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';

import style from './style.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

export const SelectedService = ({ selectedService = emptyObject, showMdash = false }) => {
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.service} />} labelClassName={style.label}>
      {showMdash && <span className={style.mdash}>&mdash;</span>}
      {!showMdash && <span className={style.info}>{selectedService.name}</span>}
    </LabeledRow>
  );
};

SelectedService.propTypes = {
  selectedService: PropTypes.object,
  showMdash: PropTypes.bool,
};
